import React from 'react';
import List from "../components/List";
import LoansDaytodayOperations from "../components/LoansDaytodayOperations";
import Overdraft from "../components/Overdraft";
import LoanDeposit from "../components/LoanDeposit";

export default function template() {
    let Component = null,
        { match = {} } = this.props;
    if (match.params.action && match.params.type) {
        switch (match.params.action) {
            case 'loans-daytoday-operations':
                Component = LoansDaytodayOperations;
                break;
            case 'overdraft':
                Component = Overdraft;
                break;
            case 'loan-deposit':
                Component = LoanDeposit;
                break;
            default:
                Component = List;
                break;
        }
    } else {
        Component = List;
    }

    return (
        <div className="module-loans-corporate-clients">
            <Component {...this.props} />
        </div>
    );
}
